<top-banner variant="small"></top-banner>


<div class="main-content">
  <div class="row animated fadeIn">

    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">

          <div class="row">
            <div class="col-md-12">
              <div class="invite-users-side-padding">
                <card-section-header
                    title="Invite Users"
                    icon="fas fa-pen-to-square">
                </card-section-header>

                <!-- Progress Bar -->
                <div class="invite-progress-bar">
                  <div class="invite-progress-bar__step"
                      [class.invite-progress-bar__step--active]="currentStep === 1"
                      [class.invite-progress-bar__step--completed]="currentStep > 1"
                      (click)="goToStep1()">
                    <div class="invite-progress-bar__circle">
                      <span *ngIf="currentStep <= 1">1</span>
                      <i *ngIf="currentStep > 1" class="fa fa-check"></i>
                    </div>
                    <span class="invite-progress-bar__label">User Details</span>
                  </div>
                  <div class="invite-progress-bar__line"
                      [class.invite-progress-bar__line--active]="currentStep > 1"></div>
                  <div class="invite-progress-bar__step"
                      [class.invite-progress-bar__step--active]="currentStep === 2">
                    <div class="invite-progress-bar__circle">2</div>
                    <span class="invite-progress-bar__label">Competencies</span>
                  </div>
                </div>

                <!-- Step 1: User Details -->
                <ng-container *ngIf="currentStep === 1">
                  <ng-container *ngIf="showSiteOwnerDropdown">
                    <div class="form-group">
                      <div class="filter-flex-row">
                        <label>Site Owner</label>
                        <span *ngIf="siteOwnersLoading" class="small-spinner-inline">
                          <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
                        </span>
                      </div>
                      <p-dropdown
                        class="form-control"
                        [(ngModel)]="selectedSiteOwner"
                        [ngModelOptions]="{standalone: true}"
                        [options]="siteOwners" (ngModelChange)="selectedSiteOwnerChange()"
                        placeholder="Select a site owner..."
                        [disableControl]="siteOwnersLoading || !siteOwners.length"
                        [style]="{'width':'100%'}"
                        filter="true">
                      </p-dropdown>
                    </div>
                  </ng-container>
                  <!-- Form -->
                  <form [formGroup]="inviteForm">

                    <div class="form-row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <div class="filter-flex-row">
                            <label>Sites <span class="required-text">(required)</span></label>
                            <span *ngIf="sitesLoading" class="small-spinner-inline">
                              <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
                            </span>
                          </div>
                          <p-multiSelect
                            [disableControl]="sitesLoading || !sitesList.length || requiresSiteOwnerSelection"
                            class="form-control"
                            formControlName="sites"
                            [options]="sitesList"
                            (onChange)="onSiteChanged($event.value)"
                            [defaultLabel]="sitesLoading ? 'Loading sites...' : (requiresSiteOwnerSelection ? 'Select a site owner first' : 'Select sites')"
                            [style]="{'width':'100%'}">
                          </p-multiSelect>
                        </div>
                      </div>

                      <div *ngIf="!isContractorManagerView" class="col-md-6">
                        <div class="form-group">
                          <div class="filter-flex-row">
                            <label>Contractor <span class="required-text">(required)</span></label>
                            <span *ngIf="contractorsLoading" class="small-spinner-inline">
                              <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
                            </span>
                          </div>
                          <p-dropdown
                            [disableControl]="requiresSiteOwnerSelection || contractorsLoading || !contractorsOptionsList.length"
                            class="form-control"
                            formControlName="contractor"
                            [placeholder]="requiresSiteOwnerSelection ? 'Select a site owner first' : (contractorsLoading ? 'Loading companies...' : 'Select a company')"
                            [ngModelOptions]="{standalone: true}"
                            [options]="requiresSiteOwnerSelection || contractorsLoading ? [] : contractorsOptionsList"
                            filter="true">
                          </p-dropdown>
                          <small
                            *ngIf="showNoLinkedContractorsMessage"
                            class="text-danger d-block mt-2">
                            There are no linked contractors for this site owner. Contact Skylark helpdesk.
                          </small>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <div class="filter-flex-row">
                            <label>Asset Categories <span class="required-text">(required)</span></label>
                            <span *ngIf="assetCategoriesLoading" class="small-spinner-inline">
                              <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
                            </span>
                          </div>
                          <p-multiSelect
                            [disableControl]="assetCategoriesLoading || !assetCategoriesOptionsList.length"
                            class="form-control"
                            formControlName="assetCategories"
                            [options]="assetCategoriesOptionsList"
                            [defaultLabel]="assetCategoriesLoading ? 'Loading categories...' : (currentNumberOfSiteTypes > 0 ? 'Select categories' : 'Select sites first')"
                            [style]="{'width':'100%'}">

                            <ng-template let-option let-i="index" pTemplate="item">
                              <ng-container *ngIf="currentNumberOfSiteTypes === 1">
                                {{option.label}}
                              </ng-container>
                              <ng-container *ngIf="currentNumberOfSiteTypes > 1">
                                {{option.label}} ({{option.siteTypeName}})
                              </ng-container>
                            </ng-template>

                          </p-multiSelect>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="form-group">
                          <div class="form-group form-group-checkbox">
                            <label for="guestsPermitted">Guests Permitted</label>
                            <p-checkbox class="form-control" inputId="guestsPermitted" formControlName="guestsPermitted" binary="true"></p-checkbox>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <div class="form-group form-group-checkbox">
                            <label for="siteSessionsPermitted">Site Sessions Permitted</label>
                            <p-checkbox class="form-control" inputId="siteSessionsPermitted" formControlName="siteSessionsPermitted" binary="true"></p-checkbox>
                          </div>
                        </div>
                      </div>
                    </div>

                  </form>

                  <p class="small-data">These options will be applied to each user you invite below</p>
                  <hr>

                  <h4 class="card-title">User Details</h4>
                  <!-- Add users -->
                  <div>
                    <form [formGroup]="addUserForm" (ngSubmit)="onUserAdd()">
                      <p-table [value]="userList" [responsive]="true" [autoLayout]="true">
                        <ng-template pTemplate="header">
                          <tr class="no-wrap-headers">
                            <th>First name <span class="required-text">(required)</span></th>
                            <th>Last name <span class="required-text">(required)</span></th>
                            <th>Email <span class="required-text">(required)</span></th>
                            <th>Phone number <span class="required-text">(required)</span></th>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-user let-i="rowIndex">
                          <tr class="animated fadeIn">
                            <td>
                              <span class="p-column-title">First name</span>
                              {{user.firstName}}
                            </td>
                            <td>
                              <span class="p-column-title">Last name</span>
                              {{user.lastName}}
                            </td>
                            <td>
                              <span class="p-column-title">Email</span>
                              {{user.email}}
                            </td>
                            <td>
                              <span class="p-column-title">Phone Number</span>
                              {{user.phoneNumber}}
                            </td>
                            <td>
                              <span class="p-column-title">Remove</span>
                              <button type="button" class="btn-link btn-danger" (click)="onUserRemove(i)"><span class="pi pi-times"></span></button>
                            </td>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="footer">
                          <tr>
                            <td>
                              <div class="form-group">
                                <input type="text" class="form-control" formControlName="firstName" placeholder="Add first name...">
                              </div>
                            </td>
                            <td>
                              <div class="form-group">
                                <input type="text" class="form-control" formControlName="lastName" placeholder="Add last name...">
                              </div>
                            </td>
                            <td>
                              <div class="form-group">
                                <input type="email" class="form-control" formControlName="email" placeholder="Add email...">
                              </div>
                            </td>
                            <td>
                              <div class="form-group">
                                <input type="text" class="form-control" formControlName="phoneNumber" placeholder="Add phone number...">
                              </div>
                            </td>
                            <td>
                              <button type="submit" class="btn btn-success btn-round float-right" [disabled]="saveInProgress">
                                Confirm Row
                              </button>
                            </td>
                          </tr>
                        </ng-template>
                      </p-table>

                      <!-- simple upright form for when the table goes into mobile view mode -->
                      <div class="mobile-only-view">
                        <div class="form-row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>First Name <span class="required-text">(required)</span></label>
                              <input type="text" class="form-control" formControlName="firstName" placeholder="Add first name...">
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>Lastname <span class="required-text">(required)</span></label>
                              <input type="text" class="form-control" formControlName="lastName" placeholder="Add last name...">
                            </div>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>Email <span class="required-text">(required)</span></label>
                              <input type="email" class="form-control" formControlName="email" placeholder="Add email...">
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>Phone number <span class="required-text">(required)</span></label>
                              <input type="text" class="form-control" formControlName="phoneNumber" placeholder="Add phone number...">
                            </div>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="col-md-12">
                            <button type="submit" class="btn btn-success btn-round float-right" [disabled]="saveInProgress">
                              Add
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="animated fadeIn" *ngIf="addUserFormValidated">
                        <div class="alert alert-warning " role="alert" *ngIf="!addUserForm.controls['firstName'].valid && addUserForm.controls['firstName'].errors?.required">
                          First name is required
                          <ng-template *ngTemplateOutlet="dismissValidationButton"></ng-template>
                        </div>
                        <div class="alert alert-warning" role="alert" *ngIf="!addUserForm.controls['firstName'].valid && addUserForm.controls['firstName'].errors?.maxlength">
                          First name cannot be longer than {{ addUserForm.controls['firstName'].errors?.maxlength.requiredLength }} characters
                          <ng-template *ngTemplateOutlet="dismissValidationButton"></ng-template>
                        </div>
                        <div class="alert alert-warning" role="alert" *ngIf="!addUserForm.controls['lastName'].valid && addUserForm.controls['lastName'].errors?.required">
                          Last name is required
                          <ng-template *ngTemplateOutlet="dismissValidationButton"></ng-template>
                        </div>
                        <div class="alert alert-warning" role="alert" *ngIf="!addUserForm.controls['lastName'].valid && addUserForm.controls['lastName'].errors?.minlength">
                          Last name cannot be shorter than {{ addUserForm.controls['lastName'].errors?.minlength.requiredLength }} characters
                          <ng-template *ngTemplateOutlet="dismissValidationButton"></ng-template>
                        </div>
                        <div class="alert alert-warning" role="alert" *ngIf="!addUserForm.controls['lastName'].valid && addUserForm.controls['lastName'].errors?.maxlength">
                          Last name cannot be longer than {{ addUserForm.controls['lastName'].errors?.maxlength.requiredLength }} characters
                          <ng-template *ngTemplateOutlet="dismissValidationButton"></ng-template>
                        </div>
                        <div class="alert alert-warning" role="alert" *ngIf="!addUserForm.controls['email'].valid && addUserForm.controls['email'].errors?.required">
                          Email is required
                          <ng-template *ngTemplateOutlet="dismissValidationButton"></ng-template>
                        </div>
                        <div class="alert alert-warning" role="alert" *ngIf="!addUserForm.controls['email'].valid && addUserForm.controls['email'].errors?.maxlength">
                          Email cannot be longer than {{ addUserForm.controls['email'].errors?.maxlength.requiredLength }} characters
                          <ng-template *ngTemplateOutlet="dismissValidationButton"></ng-template>
                        </div>
                        <div class="alert alert-warning" role="alert" *ngIf="!addUserForm.controls['email'].valid && addUserForm.controls['email'].errors?.email">
                          Email must be in the format "abcdef@example.com"
                          <ng-template *ngTemplateOutlet="dismissValidationButton"></ng-template>
                        </div>
                        <div class="alert alert-warning" role="alert" *ngIf="emailAlreadyAddedTolist">
                          Email already added to the user list above
                          <ng-template *ngTemplateOutlet="dismissValidationButton"></ng-template>
                        </div>
                        <div class="alert alert-warning" role="alert" *ngIf="!addUserForm.controls['phoneNumber'].valid && addUserForm.controls['phoneNumber'].errors?.required">
                          Phone number is required
                          <ng-template *ngTemplateOutlet="dismissValidationButton"></ng-template>
                        </div>
                        <div class="alert alert-warning" role="alert" *ngIf="!addUserForm.controls['phoneNumber'].valid && addUserForm.controls['phoneNumber'].errors?.minlength">
                          Phone number cannot be shorter than {{ addUserForm.controls['phoneNumber'].errors?.minlength.requiredLength }} characters
                          <ng-template *ngTemplateOutlet="dismissValidationButton"></ng-template>
                        </div>
                        <div class="alert alert-warning" role="alert" *ngIf="!addUserForm.controls['phoneNumber'].valid && addUserForm.controls['phoneNumber'].errors?.maxlength">
                          Phone number cannot be longer than {{ addUserForm.controls['phoneNumber'].errors?.maxlength.requiredLength }} characters
                          <ng-template *ngTemplateOutlet="dismissValidationButton"></ng-template>
                        </div>
                        <div class="alert alert-warning" role="alert" *ngIf="!addUserForm.controls['phoneNumber'].valid && addUserForm.controls['phoneNumber'].errors?.pattern">
                          Phone number cannot contain letters
                          <ng-template *ngTemplateOutlet="dismissValidationButton"></ng-template>
                        </div>
                      </div>
                    </form>
                  </div>

                  <br>
                  <br>
                  <div class="col-md-12">
                    <button type="button"
                      class="btn btn-success btn-round"
                      [disabled]="!inviteForm.valid || !userList.length || saveInProgress"
                      (click)="goToStep2()"> Save and add Competencies
                    </button>
                  </div>
                  <br>
                </ng-container>

                <!-- Step 2: Competencies -->
                <ng-container *ngIf="currentStep === 2">

                  <!-- User accordion table -->
                  <div class="invite-user-accordion">
                    <!-- Table header -->
                    <div class="invite-user-accordion__table-header">
                      <div class="invite-user-accordion__col invite-user-accordion__col--expand"></div>
                      <div class="invite-user-accordion__col">First Name <i class="fa fa-sort"></i></div>
                      <div class="invite-user-accordion__col">Last Name <i class="fa fa-sort"></i></div>
                      <div class="invite-user-accordion__col">Competencies <i class="fa fa-sort"></i></div>
                      <div class="invite-user-accordion__col">User Type</div>
                      <div class="invite-user-accordion__col invite-user-accordion__col--wide">Contractor <i class="fa fa-sort"></i></div>
                    </div>

                    <!-- User rows -->
                    <div *ngFor="let user of userList; let i = index" class="invite-user-accordion__item">
                      <!-- Row header -->
                      <div class="invite-user-accordion__header" (click)="toggleUserExpansion(i)"
                          [class.invite-user-accordion__header--expanded]="expandedUserIndex === i">
                        <div class="invite-user-accordion__col invite-user-accordion__col--expand">
                          <i class="fa" [ngClass]="{'fa-chevron-down': expandedUserIndex === i, 'fa-chevron-right': expandedUserIndex !== i}"></i>
                        </div>
                        <div class="invite-user-accordion__col">{{user.firstName}}</div>
                        <div class="invite-user-accordion__col">{{user.lastName}}</div>
                        <div class="invite-user-accordion__col">
                          <span class="badge badge-competency" *ngIf="getUserCompetencyCount(user)">
                            {{getUserCompetencyCount(user)}} Competenc{{getUserCompetencyCount(user) === 1 ? 'y' : 'ies'}}
                          </span>
                          <span *ngIf="!getUserCompetencyCount(user)" class="text-muted">0 Competencies</span>
                        </div>
                        <div class="invite-user-accordion__col">Site Worker</div>
                        <div class="invite-user-accordion__col invite-user-accordion__col--wide">{{contractorName}}</div>
                      </div>

                      <!-- Expanded body -->
                      <div *ngIf="expandedUserIndex === i" class="invite-user-accordion__body animated fadeIn">
                        <h6 class="invite-add-competencies-title">Add Competencies</h6>

                        <div class="compblock">
                          <app-add-competency-form
                            flowMode="invite"
                            [approvalMode]="addCompetencyApprovalMode"
                            [siteOwnerId]="siteOwnerId"
                            (competencyCollected)="onCompetencyCollected($event)">
                          </app-add-competency-form>
                        </div>

                        <!-- Added competency cards for this user -->
                        <div *ngIf="user.competencies.length" class="competency-card-grid mt-4">
                          <competency-card
                            *ngFor="let comp of user.competencies; let ci = index"
                            [competency]="comp.viewCompetency"
                            cardType="user-draft"
                            (evidenceRequested)="onInviteEvidenceRequested(i, ci)"
                            (delete)="removeCompetencyFromUser(i, ci)">
                          </competency-card>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Bottom actions -->
                  <div class="invite-step2-actions">
                    <button type="button"
                      class="btn btn-success btn-round btn-lg"
                      [disabled]="saveInProgress"
                      (click)="onSave()">
                      Save and Send Invites
                    </button>
                    <span class="ml-3">
                      <a href="javascript:void(0)" class="invite-skip-link invite-skip-link--lg" (click)="onSkipCompetencies()" *ngIf="!saveInProgress">
                        <i class="fa fa-times"></i> Skip Competencies
                      </a>
                    </span>
                  </div>
                </ng-container>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #dismissValidationButton let-liveSession>
  <button type="button" class="close" (click)="addUserFormValidated = false" aria-label="Close"><span aria-hidden="true">&times;</span></button>
</ng-template>
